// Reads live inventory straight from the product's own rendered PDP page
// (its embedded <script data-section-data> JSON) instead of the Shopify
// Storefront GraphQL API — a plain same-origin fetch, no API token involved.
export default async function checkInventoryAvailable(variantId, requestedQuantity, cart, currentLineKey) {
  const currentLine = cart?.state?.items?.find((item) => item.key === currentLineKey);

  // Skip check if:
  // 1. Not tracked (inventoryManagement !== 'shopify') OR
  // 2. Tracked but allows overselling (inventoryPolicy === 'continue')
  if (
    currentLine?.properties?._inventoryManagement !== 'shopify' ||
    currentLine?.properties?._inventoryPolicy === 'continue'
  ) {
    return {
      available: true,
      maxQuantity: Infinity,
    };
  }

  // Get total quantity of this variant in cart (excluding current line)
  let totalInCart = 0;
  cart?.state?.items?.forEach((item) => {
    if (item.properties?._bundleProductsId) {
      return;
    }

    const lineVariantId = String(item.variant_id);
    const compareVariantId = String(variantId);

    if (lineVariantId === compareVariantId && item.key !== currentLineKey) {
      totalInCart += item.quantity;
    }
  });

  const bareVariantId = String(variantId).includes('/ProductVariant/')
    ? variantId.split('/ProductVariant/')[1]
    : String(variantId);

  try {
    // currentLine.url is the classic Ajax cart line's product URL (with a
    // ?variant= query param) — strip it down to the bare product path.
    const productPath = currentLine?.url ? new URL(currentLine.url, window.location.origin).pathname : null;
    if (!productPath) throw new Error('checkInventoryAvailable: cart line has no product url');

    const response = await fetch(productPath);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('[data-section="product"] script[data-section-data]');
    const data = script ? JSON.parse(script.textContent) : null;

    const variant = data?.product?.variants?.find((v) => {
      const vBareId = String(v.id).includes('/ProductVariant/') ? v.id.split('/ProductVariant/')[1] : String(v.id);
      return vBareId === bareVariantId;
    });

    const quantityAvailable = variant?.inventory?.quantity ?? Infinity;
    const totalRequested = totalInCart + requestedQuantity;

    return {
      available: totalRequested <= quantityAvailable,
      maxQuantity: Math.max(0, quantityAvailable - totalInCart),
    };
  } catch (error) {
    return {
      available: true,
      maxQuantity: Infinity,
    };
  }
}
